import { useState } from 'react';

interface UseModalNavigate<T> {
  step: T;
  setStep: (step: T) => void;
  onBack: VoidFunction;
}
export const useModalNavigate = <T>(initialStep: T): UseModalNavigate<T> => {
  const [step, setModalStep] = useState<T>(initialStep);
  const [prev, setPrev] = useState<T[]>([]);
  const onBack = () => {
    setModalStep(prev.pop() ?? initialStep);
  };
  const setStep = (newStep: T) => {
    setPrev((prev) => [...prev, step]);
    setModalStep(newStep);
  };
  return { step, onBack, setStep };
};
